<template>
  <section class="py_100">
    <div class="d-flex align-items-center justify-content-center h-100 py_100">
      <div class="page_not_found text-center h-100 w-50 d-none">
        <h1 class="text-danger">SSO Login</h1>
        <h2 class="m-4 text-uppercase">Please Wait!</h2>
        <p>You are going to be authenticated</p>
        <div
          class="separator transparent center"
          style="margin-top: 35px"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
// import AuthService from "@/services/AuthService";
import { applyThemeColors } from "@/utils/helpers";

export default {
  name: "sso",
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    // Immediately try to get authenticated user via store action
    
    this.$store
      .dispatch("auth/getAuthUser")
      .then((response) => {
       
        const { user, client } = response;
        // Store needed details in localStorage if required
        window.localStorage.setItem("employeeEmail", user.email);
        window.localStorage.setItem("user_profile", user.avatar);
        window.localStorage.setItem(
          "companyInformation",
          JSON.stringify(client)
        );
        window.localStorage.setItem("loginType", user.login_type);

        // Apply theme colors immediately after setting companyInformation
        applyThemeColors(client);

        // Redirect based on company code
        if (["airbnb", "a45"].includes(client.company_code.toLowerCase())) {
          this.$router.replace({ path: "/airbnb" });
        } else {
          this.$router.replace({ path: "/user" });
        }
      })
      .catch((error) => {
        this.$toast.error(
          error.response?.data?.error || "Authentication failed",
          { position: "top-right" }
        );
        this.$router.replace({ name: "login" });
      });
  },
};
</script>
